/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DnsDomainObject } from 'cio/models/domain';
import { DomainVerificationSection } from 'cio/components/domain/verify-authentication';

interface DomainVerifyAuthenticationSectionComponentArgs {
  type: DomainVerificationSection;
  explanation: string;
  parentDomain: string;
  records: DnsDomainObject[];
  verified: boolean;
  verifiedAllowsNull?: boolean;
  expanded: boolean;
  toggleSection: () => unknown;
}

export default class DomainVerifyAuthenticationSectionComponent extends Component<DomainVerifyAuthenticationSectionComponentArgs> {
  get checkIcon() {
    let { verified, verifiedAllowsNull } = this.args;

    if (verifiedAllowsNull === true && verified === false) {
      return 'error';
    }

    return 'check-circle';
  }

  get checkIconFill() {
    let { verified, verifiedAllowsNull } = this.args;

    if (verifiedAllowsNull === true) {
      if (verified === false) {
        return 'danger';
      }
    }

    if (verified === true) {
      return 'success';
    }

    return 'muted';
  }

  get name() {
    switch (this.args.type) {
      case DomainVerificationSection.Mx:
        return 'MX Records';
      case DomainVerificationSection.Spf:
        return 'SPF Record';
      case DomainVerificationSection.Dkim:
        return 'DKIM Record';
      case DomainVerificationSection.Ownership:
        return 'Ownership Record';
      case DomainVerificationSection.Dmarc:
        return 'DMARC Record';
      default:
        return;
    }
  }

  get tooltipContent() {
    switch (this.args.type) {
      case DomainVerificationSection.Mx:
        return 'MX (mail exchange) records map a domain name to a mail server receiving email for that domain. MX records identify which mail servers others use to send email to a domain.';
      case DomainVerificationSection.Spf:
        return 'An SPF (Sender Policy Framework) record identifies which IP addresses are allowed to send email using your domain. Verifying its ownership allows Customer.io to sign emails sent on your behalf.';
      case DomainVerificationSection.Dkim:
        return 'DKIM (Domain Keys Identified Mail) signatures ensure that the message that arrives at the inbox provider is identical to the message that you sent. Verifying its ownership allows Customer.io to sign emails sent on your behalf.';
      case DomainVerificationSection.Ownership:
        return null;
      case DomainVerificationSection.Dmarc:
        return 'A DMARC (Domain-based Message Authentication, Reporting, and Conformance) policy helps prevent email spoofing and phishing attacks by allowing senders to specify how inbox providers like Gmail handle unauthenticated emails.';
      default:
        return;
    }
  }
}
